<template>
  <div class="newscenter-container">
    <div class="banner-container">
      <div class="banner-content">
        <div class="banner-title">新闻中心</div>
        <div class="banner-info">了解优图最新动态</div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'NewsCenter'
};
</script>

<style lang="less" scoped>
.newscenter-container{
  background-color: #ffffff;
  div{
    box-sizing: border-box;
  }
  .banner-container{
    width: 100%;
    color: #ffffff;
    background-image: url(./img/banner_news.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    .banner-content{
      width: 1263px;
      height: 360px;
      padding-left: 30px;
      margin: 60px auto 0;
      .banner-title{
        font-size: 40px;
        font-family: 'PingFangSC-Medium';
        color: #000000;
        font-weight: 500;
        padding-top: 125px;
      }
      .banner-info{
        height: 32px;
        font-size: 18px;
        color: #3D485D;
        line-height: 32px;
        margin-top: 10px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/NewsCenter.vue